import { queryOptions } from '@tanstack/react-query';
import { type GetReleaseNotesResponse } from '../types/battery-monitoring-api';
import { batteryMonitoringApi } from '../battery-monitoring-api';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- queryOptions as return type should be inferred
export const getReleaseNotesQueryOptions = () => {
  return queryOptions<GetReleaseNotesResponse>({
    queryKey: ['getReleaseNotes'],
    queryFn: async () => await batteryMonitoringApi.getReleaseNotes(),
  });
};
